import React, { useEffect, useState } from 'react';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      setDeferredPrompt(e.detail);
      setShowPrompt(true);
    };
    window.addEventListener('showInstallPrompt', handler);
    return () => window.removeEventListener('showInstallPrompt', handler);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        console.log('L’utilisateur a accepté l’installation');
      } else {
        console.log('L’utilisateur a refusé l’installation');
      }
      setDeferredPrompt(null);
      setShowPrompt(false);
    }
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-indigo-600 text-white px-4 py-3 rounded-lg shadow-lg z-50">
      <p className="mb-2 text-sm">Tu veux ajouter Mi-Parcours à ton écran d’accueil ?</p>
      <button
        onClick={handleInstall}
        className="bg-white text-indigo-600 font-semibold px-3 py-1 rounded hover:bg-gray-100"
      >
        📲 Ajouter maintenant
      </button>
    </div>
  );
};

export default InstallPrompt;
